import { type FC } from 'react';
import type { NodeProps } from 'reactflow';
import type { NodeData } from '@/types/node.types';
import BaseNode from './BaseNode';

const STAKEHOLDER_COLOR = '#EC4899';

export const StakeholderNode: FC<NodeProps<NodeData>> = ({ id, data, selected }) => {
  return <BaseNode id={id} data={data} color={STAKEHOLDER_COLOR} icon={'\u{1F465}'} selected={selected} />;
};

export default StakeholderNode;
